export const directEnterRoutes = ['chat', 'order', 'question'];
// 在 customer_service_order 里面，只能跳转到 chat，不能跳转到 order，否则会再跳转到 H5 的order，这样会不符合预期，故order 页面只能跳转 chat
export const directEnterRoutesInOrder = ['chat'];

export const CustomerCid = {
  HomePage: 'c_oversea_helpcenter_kr34yt2v',
  OrderPage: 'c_oversea_helpcenter_rqhfdnvm',
  QuestionPage: 'c_oversea_helpcenter_kxpe84d2',
  ServiceProgressPage: 'c_oversea_helpcenter_oa3acr9m',
  HistoryMessage: 'c_oversea_helpcenter_nr94vc1e'
};

// i18n时间治理SDK 兜底城市id统一收口; 兜底香港
export const DEFAULT_CITY_ID = '810001';

export const SDK_FORMAT_STR = 'yyyy-MM-dd HH:mm:ss'; // machpro SDK 年月日 时分秒 转换格式
